import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {NgxIntlTelInputModule} from '@justin-s/ngx-intl-tel-input';
import {NumberOnlyDirective} from '../../../../../../directives/numberOnly.directive';
import {FormsModule} from '@angular/forms';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {DatePipe, NgClass, NgFor, NgIf} from '@angular/common';
import {MatFormField} from '@angular/material/form-field';
import {MatOption} from '@angular/material/autocomplete';
import {MatSelect} from '@angular/material/select';
import { ItemBadgesComponent } from "../../../../../../shared/components/item-badges/item-badges.component";

@Component({
  selector: 'app-filter-content',
  templateUrl: './filter-content.component.html',
  styleUrls: ['./filter-content.component.scss'],
  imports: [NgFor, MatCheckboxModule, FormsModule, NumberOnlyDirective, NgxIntlTelInputModule, NgIf, NgClass, TranslateModule, MatFormField, MatOption, MatSelect, DatePipe, ItemBadgesComponent],
  standalone: true,
  providers: [
    DatePipe,
  ]
})
export class FilterContentComponent implements OnInit {

  @Input() public readonly rangeLimits;
  @Input() public readonly type: 'alert' | 'filter' = 'filter';
  @Input() public filters: any = {
    minPrice: null,
    maxPrice: null,
    minMeter: null,
    maxMeter: null,
    wc: null,
    bathrooms: null,
    is_studentResidence: null,
    tenants_gender: [],
    duration: [],
    selectedBadge: null,
    type: [],
    tenants: [],
    empty_rooms: [],
    arrivalDate: null,
    departureDate: null,
    durationDate: null,
  };
  @Output() private sendNewFilters: EventEmitter<any> = new EventEmitter<any>();

  public arrivalArray = [];
  public departureArray = [];
  public locale: string = 'en';

  constructor(
    private _translateService: TranslateService,
    private datePipe: DatePipe,
  ) {
  }

  ngOnInit(): void {
    this.locale = this._translateService.currentLang;
    if (this.type === 'alert') {
      this.createArrivalDepartureMonths();
    }
  }

  public sendChanges(): void {
    // Reset les filtres colocataires au besoin
    if (this.filters.type.length === 1 && this.filters.type.indexOf('apartment') !== -1) {
      this.filters.bathrooms = null;
      this.filters.wc = null;
      this.filters.empty_rooms = [];
      this.filters.tenants = [];
      this.filters.tenants_gender = [];
    }
    this.sendNewFilters.emit(this.filters);
  }

  public updateFilters(filterKey: string, value): void {
    if (this.filters[filterKey].indexOf(value) === -1) {
      this.filters[filterKey].push(value);
    } else {
      this.filters[filterKey].splice(this.filters[filterKey].indexOf(value), 1);
    }
    this.sendChanges();
  }

  public trackByIndex(index, item): number {
    return index;
  }

  public selectDate(value): void {
    const today = new Date();
    if (value) {
      // Set la date de début, soit aujourd'hui, soit la date de départ choisie
      let start: Date = new Date(today.getFullYear(), today.getMonth(), 1);
      if (this.filters.arrivalDate) {
        start = new Date(this.filters.arrivalDate);
      }

      // Set durationDate s'il y a une date de départ
      if (this.filters.departureDate) {
        const depart = new Date(this.filters.departureDate);
        const timeDiff = depart.getTime() - start.getTime();
        this.filters.durationDate = Math.floor(timeDiff / (1000 * 60 * 60 * 24 * 30));
        if (this.filters.durationDate === 0) {
          this.filters.durationDate = 1;
        }
      }
    } else {
      this.filters.durationDate = null;
    }
  }

  private createArrivalDepartureMonths(): void {
    const today = new Date();
    let i = 0;
    do {
      if (i < 24) {
        this.arrivalArray.push(this.datePipe.transform(new Date(today.getFullYear(), today.getMonth() + i, 1), 'yyyy-MM-dd'));
      }
      this.departureArray.push(this.datePipe.transform(new Date(today.getFullYear(), today.getMonth() + i + 2, 0), 'yyyy-MM-dd'));
      i++;
    } while (i < 36);
  }

  public updateBadge(badge: string): void {
    if (this.filters.selectedBadge === badge) {
        this.filters.selectedBadge = null;
    } else {
        this.filters.selectedBadge = badge;
    }
    this.sendChanges();
}
}
